// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  name: __t.string(),
  stake: __t.u32(),
  mode: __t.string(),
  room: __t.string(),
  boostEnabled: __t.bool(),
  accountId: __t.option(__t.string()),
  botFallbackSeconds: __t.option(__t.u32()),
};
